$('.block-image-slider').each(function() {

    const slider   = $(this);
    const swiperEl = slider.find('.swiper')[0];

    if (!swiperEl) return;

    const swiper = new Swiper(swiperEl, {
        allowTouchMove: true,
        keyboard: {
            enabled: true,
        },
		loop: true,
		speed: 500,
		navigation: {
			nextEl: slider.find('.swiper-arrow.next')[0],
			prevEl: slider.find('.swiper-arrow.prev')[0],
		},
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        spaceBetween: global_helpers.defaults.slide_spacing,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        breakpoints: {
            782: {
                slidesPerView: 1.5,
            },
        }
    });

});
